try {
    window.axios = require('axios');

    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('../vendors/jquery.onepage-scroll.js');
    require('jquery-validation');

    const Isotope = require('isotope-layout');
    const jQueryBridget = require('jquery-bridget');
    jQueryBridget( 'isotope', Isotope, $ );
} catch (e) {}
